<template>
  <div class="translation-links">
    <ul class="nav nav-tabs">
      <li class="nav-item active">
        <a class="nav-link active show" aria-selected="true" data-toggle="tab" role="tab" href="#1" @click.prevent="changeLocale('da-DK')">Dansk</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-toggle="tab" role="tab" href="#2" @click.prevent="changeLocale('en-UK')">English</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  methods: {
    changeLocale(locale) {
      this.$store.commit('updateFormLocale', locale);
    },
  },
};
</script>